import { useRouter } from "next/router";

export const useBlogCategories = () => {
  const router = useRouter();

  const categoryQuery = router?.query?.category;

  const onApplyFilter = (category: string) => {
    const query = { ...router.query };

    if (category === "") {
      delete query.category;
    } else {
      query.category = category;
    }

    router.push(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true }
    );
  };

  return {
    categoryQuery,
    onApplyFilter,
  };
};
